import * as yup from 'yup';
import { PhotoLabelsOverlay } from '@web/molecules';

export const component = PhotoLabelsOverlay;

const photoLabelSchema = yup
  .object({
    label: yup.string(),
    labelTypography: yup.string(),
    labelFontColor: yup.string(),
    description: yup.string(),
    descriptionTypography: yup.string(),
    descriptionFontColor: yup.string(),
    top: yup.number(),
    left: yup.number(),
    topMobile: yup.number(),
    leftMobile: yup.number(),
    cornerDotAlignment: yup.string(),
  })
  .transform(value => ({
    label: value.label,
    labelTypography: value.label_typography || undefined,
    labelFontColor: value.label_font_color || undefined,
    description: value.description,
    descriptionTypography: value.description_typography || undefined,
    descriptionFontColor: value.description_font_color || undefined,
    top:
      value.top === '' || isNaN(Number(value.top))
        ? undefined
        : Number(value.top),
    left:
      value.left === '' || isNaN(Number(value.left))
        ? undefined
        : Number(value.left),
    topMobile:
      value.top_mobile === '' || isNaN(Number(value.top_mobile))
        ? undefined
        : Number(value.top_mobile),
    leftMobile:
      value.left_mobile === '' || isNaN(Number(value.left_mobile))
        ? undefined
        : Number(value.left_mobile),
    cornerDotAlignment: value.corner_dot_alignment
      ? value.corner_dot_alignment
      : 'left',
  }));

export const schema = yup
  .object({
    showAnimation: yup.boolean(),
    photoLabels: yup.array(photoLabelSchema),
  })
  .transform(value => ({
    showAnimation: value.show_animation,
    photoLabels: value.photo_labels || [],
  }));
